import { cloneElement, useEffect, useState } from 'react'
import { useLocation, useOutlet } from 'react-router-dom'
import { AnimatePresence } from 'motion/react'
import Header from './header'
import ArrowNav from './arrowNav'

export default function Layout ({ data }) {
  const location = useLocation()
  const element = useOutlet()
  const hideHeader = location.pathname === '/'
  const [backgroundColor, setBackgroundColor] = useState('#f9423a')

  useEffect(() => {
    if (location.state?.background) {
      setBackgroundColor(location.state.background)
    }
  }, [location.state])

  return (
    <main className={`h-100 ${hideHeader && 'pt-0'}`} style={{ backgroundColor }}>
      <Header links={data.navigation} hide={hideHeader} />
      <AnimatePresence>
        {element && cloneElement(element, { key: location.pathname })}
      </AnimatePresence>
      <ArrowNav data={data} />
    </main>
  )
}
